<template>
  <div class="c-media-box"  @click="toArticlePage">
    <img class="media__img" :src="data.imgPath" />
    <p class="media__title">{{ data.title }}</p>
    <p class="media__desc">{{ data.desc }}</p>

  </div>
</template>
<script>
import { defineComponent } from 'vue';
import { useRouter } from 'vue-router';

export default defineComponent({
  name: 'LessonActivityBox',
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const router = useRouter();
    const toArticlePage = () => {
      console.log('props.data.id', props.data.id);
      router.push({
        name: 'activity-lesson',
        query: {
          id: props.data.id,
        },
      });
    };

    return {
      toArticlePage,
    };
  },
});
</script>
<style lang="scss" scoped>
@import '~@/styles/utils/_rwd.scss';
.c-media-box {
  width: 100%;
  display: flex;
flex-direction: column;
}

.media {
  &__img {
    width: 100%;
    // height: 200px;
    border-radius: 20px;
  }

  &__type {
    &__box {

      padding: 0 14px;
      display: inline-block;
      margin-top: 28px;
      background-color: rgba($c-main-yellow, 0.5);
      border-radius: 10px;

      &__text {
        @include font-normal();
      }
    }
  }

  &__title {
    white-space: normal;
    @include font-style($c-main-brown, 20, 400, 1px, 28px);
    margin-top: 12px;
    height: 56px;
    @include word-ellipsis(2)
  }

  &__desc {
    margin-top: 12px;
    @include font-normal();
    @include font-style($c-main-brown, 16, 400, 1.2px, 28px);
    white-space: normal;
    @include word-ellipsis(5)
  }

  &__btn {
    margin-top: 40px;
  }
}

.media {
  &__btn-date {
    @include flex(flex-start, flex-start, column);

    &__date {
      margin-bottom: 30px;
      @include font-normal();
    }
  }
}

@media screen and (min-width: $pc) {
  .media {
    &__btn-date {
      @include flex(space-between, center, row);

      &__date {
        margin-bottom: 0px;
        flex: 2;
      }

      &__btn {
        flex: 1;
      }
    }
  }
}
</style>
